import { normalizarData, normalizarValor } from '../../utils';

/**
 * Retorna TRUE se o array de dados se parecer com um extrato CSV do Mercado Pago.
 * Verifica a presença do cabeçalho em inglês.
 */
export const detectar = (dadosArray) => {
    for (let i = 0; i < Math.min(dadosArray.length, 10); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        const str = linha.map(col => String(col || '').toUpperCase().trim());
        
        // Verifica a assinatura única do Mercado Pago
        if (str.some(c => c.includes('RELEASE_DATE')) && str.some(c => c.includes('TRANSACTION_NET_AMOUNT'))) {
            return true;
        }
        if (str.some(c => c.includes('INITIAL_BALANCE')) && str.some(c => c.includes('FINAL_BALANCE'))) {
            return true;
        }
    }
    return false;
};

/**
 * Processa a planilha bruta e retorna array mapeado.
 */
export const processar = (dadosArray) => {
    let idxCabecalho = -1;
    let idxData = -1;
    let idxDescricao = -1;
    let idxValor = -1;

    // Encontrar cabeçalho principal
    for (let i = 0; i < Math.min(dadosArray.length, 10); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        const str = linha.map(col => String(col || '').toUpperCase().trim());
        
        const possibleDataIdx = str.findIndex(c => c === 'RELEASE_DATE');
        const possibleDescricaoIdx = str.findIndex(c => c === 'TRANSACTION_TYPE');
        const possibleValorIdx = str.findIndex(c => c === 'TRANSACTION_NET_AMOUNT');

        if (possibleDataIdx !== -1 && possibleValorIdx !== -1) {
            idxCabecalho = i;
            idxData = possibleDataIdx;
            idxDescricao = possibleDescricaoIdx;
            idxValor = possibleValorIdx;
            break;
        }
    }

    if (idxCabecalho === -1) {
        throw new Error('Cabeçalho de Extrato Mercado Pago não encontrado. Verifique as colunas "RELEASE_DATE" e "TRANSACTION_NET_AMOUNT".');
    }

    const extrato = [];

    for (let i = idxCabecalho + 1; i < dadosArray.length; i++) {
        const linha = dadosArray[i];
        if (!linha || linha.length === 0) continue;

        const dataStrRaw = String(linha[idxData] || '').trim();
        if (!dataStrRaw) continue;

        // O Mercado Pago manda "DD-MM-YYYY", precisamos trocar para "DD/MM/YYYY" 
        // para garantir que a função normalizarData leia corretamente.
        const dataStr = dataStrRaw.replace(/-/g, '/');
        const data = normalizarData(dataStr);
        if (!data) continue;

        const valorStr = String(linha[idxValor] || '').trim();
        if (!valorStr) continue;

        const descricao = idxDescricao !== -1 ? String(linha[idxDescricao] || '').trim() : 'Mercado Pago';

        const valor = normalizarValor(valorStr);

        // Apenas entradas de dinheiro
        if (valor !== null && valor > 0) {
            extrato.push({
                linha: i + 1,
                data: data,
                valor: valor,
                tipo: descricao,
                dataOriginal: dataStrRaw,
                valorOriginal: valorStr
            });
        }
    }

    return extrato;
};
